<div class="container">
  <span class="top-link-row">
    <span (click)="navigateBack()" class="returnButton">< License Batches</span>
  </span>

  <app-header [title]="'License Batch Details'">
    <div class="header-actions" header-button>
      <app-button
        *ngIf="!loading && batch && canManageLicenseAssignments"
        [black]="true"
        [title]="isUserTarget ? 'Manage Users' : 'Manage Devices'"
        (click)="
          isUserTarget ? navigateToManageUsers() : navigateToManageDevices()
        "
      ></app-button>
      <app-button
        *ngIf="!loading && batch && canOverrideSoftware"
        [black]="true"
        [title]="'Override Software'"
        (click)="openSoftwareOverride()"
      ></app-button>
      <app-button
        *ngIf="!loading && batch && isMasterAdmin"
        [black]="true"
        [title]="'Edit Batch'"
        (click)="navigateToManageBatch()"
      ></app-button>
    </div>
  </app-header>

  <div class="status-card" *ngIf="loading">
    Loading license batch details...
  </div>

  <div class="content" *ngIf="!loading && batch">
    <section class="details-card">
      <div class="details-head">
        <div>
          <h2>{{ detailsTitle }}</h2>
          <span class="batch-id">ID: {{ batchId }}</span>
        </div>
      </div>

      <div class="details-grid">
        <div class="details-item">
          <span class="label">Description</span>
          <span class="value">{{ batch.description || 'Not set' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Company</span>
          <span class="value">{{ companyLabel }}</span>
        </div>
        <div class="details-item">
          <span class="label">Licensed Product</span>
          <div
            class="chip-list"
            *ngIf="productLabel !== 'Not assigned'; else noProduct"
          >
            <span class="component-chip">{{ productLabel }}</span>
          </div>
          <ng-template #noProduct>
            <span class="value">Not assigned</span>
          </ng-template>
        </div>
        <div class="details-item">
          <span class="label">Scope</span>
          <div
            class="chip-list"
            *ngIf="scopeLabel !== 'Not assigned'; else noScope"
          >
            <span class="component-chip">{{ scopeLabel }}</span>
          </div>
          <ng-template #noScope>
            <span class="value">Not assigned</span>
          </ng-template>
        </div>
        <div class="details-item">
          <span class="label">Components</span>
          <div
            class="chip-list"
            *ngIf="componentNames.length > 0; else noComponents"
          >
            <span
              class="component-chip"
              *ngFor="let componentName of componentNames"
            >
              {{ componentName }}
            </span>
          </div>
          <ng-template #noComponents>
            <span class="value">Not set</span>
          </ng-template>
        </div>
        <div class="details-item" *ngIf="batch.softwareVersionOverrides">
          <span class="label">Software Overrides</span>
          <div
            class="chip-list"
            *ngIf="softwareOverrideLabels.length > 0; else noSoftwareOverrides"
          >
            <span
              class="component-chip"
              *ngFor="let overrideLabel of softwareOverrideLabels"
            >
              {{ overrideLabel }}
            </span>
          </div>
          <ng-template #noSoftwareOverrides>
            <span class="value">Not set</span>
          </ng-template>
        </div>
        <div class="details-item">
          <span class="label">Valid From</span>
          <span class="value">{{ formatDate(batch.optionalValidAfter) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Valid To</span>
          <span class="value">{{ formatDate(batch.optionalValidBefore) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Auto-Assign Device Type</span>
          <span class="value">{{
            batch.autoAssignDeviceWithHardwareComponent || 'Not set'
          }}</span>
        </div>
        <div
          class="details-item"
          *ngIf="(batch.unlicensedAutoAssignableDeviceCount ?? 0) > 0"
        >
          <span class="label">Devices Without A License</span>
          <span class="value">
            {{ batch.unlicensedAutoAssignableDeviceCount }} matching device(s)
            are not currently licensed from this batch.
          </span>
        </div>
        <div class="details-item">
          <span class="label">Batch Size</span>
          <span class="value">{{ batch.licenseBatchSize ?? 0 }}</span>
        </div>
        <div class="details-item">
          <span class="label"
            >Linked {{ isUserTarget ? 'Users' : 'Devices' }}</span
          >
          <span class="value">{{
            isUserTarget ? linkedUsersCount : linkedDevicesCount
          }}</span>
        </div>
      </div>
    </section>

    <section
      class="table-section"
      *ngIf="batch.licenseRedemptionInfo && !isUserTarget"
    >
      <h3>Software Selection</h3>
      <app-effective-software-selection
        [resolutions]="batch.licenseRedemptionInfo.components"
        [showHeading]="false"
        [forLicenseBatch]="true"
      ></app-effective-software-selection>
    </section>

    <section class="table-section" *ngIf="!isUserTarget">
      <h3>Linked Devices</h3>
      <qs-table
        [data]="linkedDevicesRows"
        [columns]="columns"
        [isSearchEnabled]="isSearchEnabled"
        [isPaginatorEnabled]="isPaginatorEnabled"
        [paginatorConfig]="paginatorConfig"
      ></qs-table>
    </section>

    <section class="table-section" *ngIf="isUserTarget">
      <h3>Linked Users</h3>
      <qs-table
        [data]="linkedUsersRows"
        [columns]="userColumns"
        [isSearchEnabled]="isSearchEnabled"
        [isPaginatorEnabled]="isPaginatorEnabled"
        [paginatorConfig]="paginatorConfig"
      ></qs-table>
    </section>
  </div>
</div>
